<template>
    <ValidationProvider
        v-slot="{ errors }"
        :name="label"
        :vid="name"
        :rules="rules"
    >
        <NumberField
            v-model="innerValue"
            :errors="errors"
            v-bind="{...$attrs, ...$props}"
        />
    </ValidationProvider>
</template>

<script>
import ValidationProvider from '@/validator';
import NumberField from '../NumberField.vue';
import fieldMixin from '@/mixins/fieldMixin';
export default {
    components: {
        ValidationProvider,
        NumberField,
    },
    mixins: [fieldMixin],
    props: {
        value: {
            type: null,
            required: true,
        },
        rules: {
            type: String,
            default: '',
        },
    },
};
</script>

<style></style>
